import { Flex } from "@chakra-ui/react";
import AdminNavbarLinks from "./NavbarLinksAdmin";
function AdminNavbar({ routes, onLinkClick, activePath, onOpen }) {

  return (
    <div className="home-navbar">
      <div className="home-navbar-container">
        <div className="navbar-content">
          <Flex
            direction="column"
            align="center"
            gap="8px"

          >
            <AdminNavbarLinks
              onOpen={onOpen}
              onLinkClick={onLinkClick}
              routes={routes}
              activePath={activePath}
            />


          </Flex>

        </div>

      </div>

    </div>

  );
}

export default AdminNavbar;
